import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PncLogo from '@/components/PncLogo';
import PncFooter from '@/components/PncFooter';

export const LegalSection = ({ n, title, children }) => (
  <section className="pnc-card rounded-lg p-7 sm:p-9">
    <h2 className="serif text-xl sm:text-2xl mb-4 text-[var(--text)]">
      <span className="text-[var(--silver)] mr-2">{n}.</span>{title}
    </h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-[var(--muted)] [&_strong]:text-[var(--text)] [&_a]:underline [&_a]:underline-offset-4 [&_a]:text-[var(--text)] [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2">
      {children}
    </div>
  </section>
);

export default function LegalShell({ eyebrow, title, reviewed = '15 July 2026', children, testId }) {
  return (
    <div data-testid={testId || 'legal-page'} className="min-h-screen grain">
      <header className="relative z-10 border-b border-[var(--line)] bg-[#0A0A0A]/80 backdrop-blur-md sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center">
            <img src="/pnc-logo-white.png" alt="PNC UNIQUE LTD" className="h-9 w-auto" />
          </Link>
          <Link to="/" data-testid="legal-back-home" className="inline-flex items-center gap-2 text-sm text-[var(--muted)] hover:text-white transition-colors">
            <ArrowLeft size={15} strokeWidth={2} /> Back to portal
          </Link>
        </div>
      </header>

      <main className="relative z-10 max-w-4xl mx-auto px-6 pt-16 pb-24">
        <div className="text-center mb-14">
          <PncLogo size="md" caption={false} linkTo={null} />
          <p className="field-label mt-8 mb-4">{eyebrow}</p>
          <h1 className="serif text-4xl sm:text-5xl lg:text-6xl leading-tight">{title}</h1>
          <p className="text-sm text-[var(--muted)] mt-4">Last reviewed: {reviewed}</p>
        </div>
        <div className="space-y-6">{children}</div>
      </main>

      <PncFooter />
    </div>
  );
}
